import { reactive, toRefs, onBeforeMount, onUnmounted } from "vue";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
export function useBreakpoints() {
  var state = reactive({
    isDesktopMode: false,
    isSmall: false,
    isLarge: false,
    isMedium: false,
    isExtraLarge: false
  });
  var setDeviceMode = () => {
    state.isDesktopMode = window.innerWidth > BREAKPOINT.SMALL;
    state.isSmall = window.innerWidth <= BREAKPOINT.SMALL;
    state.isMedium = window.innerWidth > BREAKPOINT.SMALL;
    state.isLarge = window.innerWidth > BREAKPOINT.MEDIUM;
    state.isExtraLarge = window.innerWidth > BREAKPOINT.LARGE;
  };
  onBeforeMount(() => {
    setDeviceMode(); //Initializing the variables
    window.addEventListener("resize", setDeviceMode);
  });
  onUnmounted(() => {
    window.removeEventListener("resize", setDeviceMode);
  });
  return toRefs(state);
}